"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIZE_MAPPER = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var AvatarBase_1 = __importDefault(require("./AvatarBase"));
var StyledAvatar = (0, styles_1.styled)(material_1.Avatar, { shouldForwardProp: function (prop) { return prop !== 'size'; } })(function (_a) {
    var size = _a.size;
    return (__assign(__assign({ backgroundColor: 'transparent' }, (size && exports.SIZE_MAPPER[size] && {
        width: exports.SIZE_MAPPER[size],
        height: exports.SIZE_MAPPER[size],
    })), { '&.MuiAvatar-circular': {
            boxShadow: '0 1px 2px 0.5px rgb(255 159 191 / 80%)',
        }, '& > img': {
            display: 'inline-block',
            verticalAlign: 'middle',
            objectFit: 'contain',
            height: '100%',
            width: '100%',
        } }));
});
exports.SIZE_MAPPER = {
    xxs: 24, xs: 36, sm: 42, md: 63, lg: 91, xl: 140,
};
var AvatarMUI = function (_a) {
    var profile = _a.profile, props = __rest(_a, ["profile"]);
    return ((0, jsx_runtime_1.jsx)(StyledAvatar, __assign({}, props, { className: props.className }, { children: (0, jsx_runtime_1.jsx)(AvatarBase_1.default, { profile: profile }) })));
};
exports.default = (0, DefaultPropsHoC_1.default)(AvatarMUI, { variant: 'square' });
